import React, { useState, useContext } from 'react'
import {
  Card,
  Divider,
  CardContent,
  CardActions,
  CardHeader,
  Typography,
  Box,
  Grid,
} from '@mui/material'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import { LocalStorage } from '../../../services'
import { AuthContext } from '../../../contexts/AuthContext'

import moment from 'moment'

export default function DiariaButton({ diaria, isSelected = false }) {
  const { sttAuthCtx } = useContext(AuthContext)
  const { sttPg, actionsCtxEmps } = useContext(EmpresasContext)
  const { actionsChkt, sttCtxChkt } = useContext(CheckoutContext)
  const [hover, setHover] = useState(isSelected)

  let formaPagamento = diaria.formaPagamento.replace(/[[]\s]/g, '').split(',')

  const metodosFormatados = formaPagamento.map(metodo => {
    switch (metodo) {
      case 'PIX':
        return 'PIX'
      case 'CARTAO_CREDITO':
        return 'Cartão de Crédito'
      case 'LOCAL':
        return 'Pagamento Local'
      case 'DINHEIRO':
        return 'Dinheiro'
      case 'MAQUINA_CARTAO':
        return 'Máquina de Cartão'
      default:
        return metodo
    }
  })

  const regrasCancelamento = regra => {
    switch (regra) {
      case 'DIA':
        return 'Até 1 dia de antecedência'
      case 'NAO':
        return 'Não poderá cancelar'
      case 'SEMPRE':
        return 'Você pode cancelar a qualquer momento'
      default:
        return 'Sem regra de cancelamento'
    }
  }

  function sendToCheckout() {
    if (sttAuthCtx.isMobile) {
      if (!sttCtxChkt.diaria) {
        diaria.metodosPagamento = metodosFormatados
        diaria.pagamentoSelecionado = ''
        actionsChkt.handleSttCtxChkt('diaria', diaria)
        LocalStorage.set('diaria-selecionada', diaria)
      } else {
        actionsChkt.handleSttCtxChkt('diaria', null)
        LocalStorage.remove('diaria-selecionada')
      }
    } else {
      const objtCkt = {
        ...diaria,
        metodosPagamento: metodosFormatados,
        agenda: diaria.duracao,
        valorTotal: parseFloat(diaria.valor),
        dia: moment(sttPg.selectedDay).format(),
      }
      LocalStorage.set('diaria-selecionada', objtCkt)
      actionsChkt.handleSttCtxChkt('diaria', objtCkt)
      actionsCtxEmps.confirmarPedido()
    }
  }

  return (
    <button
      className={`${sttAuthCtx.isMobile ? 'tw-w-full' : 'tw-w-80'}  tw-text-start`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={sendToCheckout}
    >
      <Card
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          '.MuiCardHeader-action': { alignSelf: 'center', marginRight: '2px' },
          boxShadow: hover && !sttAuthCtx.isMobile ? '0px 4px 4px rgba(0, 0, 0, 0.25)' : 'none',
          border: hover ? '2px solid #12C06A' : '2px solid #E0E0E0',
          borderRadius: '10px',
        }}
      >
        <CardHeader
          sx={{ padding: 0, margin: 1, paddingLeft: 1 }}
          title={
            <Typography variant='h6' color={'primary'}>
              {diaria.titulo}
            </Typography>
          }
          action={
            <Typography variant='body1'>
              {diaria.valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Typography>
          }
        />
        <Divider variant='middle' />
        <CardContent sx={{ padding: 2 }}>
          <Typography variant='h7' color={'primary'}>
            REGRAS
          </Typography>
          <Box sx={{ paddingLeft: 1 }}>
            <Grid container spacing={0}>
              <Grid item xs={6}>
                <Typography variant='body2'>Forma de pagamento:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='body2' textAlign={'right'}>
                  {metodosFormatados.length > 2
                    ? `${metodosFormatados.slice(0, -1).join(', ')} e ${metodosFormatados.slice(-1)}`
                    : metodosFormatados.join(' e ')}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='body2'>Duração: </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='body2' textAlign={'right'}>
                  {diaria.duracao}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant='body2'>Cancelamento: </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant='body2' textAlign={'right'}>
                  {regrasCancelamento(diaria.usuarioPodeCancelar)}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='body2'>Valida para: </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='body2' textAlign={'right'}>
                  {diaria.quadra}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
        <Box sx={{ flexGrow: '1px' }} />
        {!sttAuthCtx.isMobile && (
          <CardActions disableSpacing={true}>
            <Box
              sx={{
                p: 1,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: hover ? '1px solid' : 'none',
                backgroundColor: hover ? 'transparent' : 'primary.main',
                color: hover ? 'primary.main' : 'white',
              }}
            >
              Escolher diária
            </Box>
          </CardActions>
        )}
      </Card>
    </button>
  )
}
